import React from 'react';
import Tooltip from '../Tooltip';
import IconInfoLight from '../../components/icon/IconInfoLight';

type Props = {
  id: string
  label?: string
  tooltip?: React.ReactNode
  required?: boolean
}

export default function FormField({
  id, label, tooltip, required,...props
}: React.PropsWithChildren<Props>) {
  const labelId = `label${id}`;

  return (
    <div className="grid grid-cols-6 gap-3 py-2 mb-1">
      <label className="block mt-4">
        <span>{label}</span>
        {required && <span className="text-red pl-1">*</span>}
        {tooltip &&
        <>
          <Tooltip content={tooltip}
            label={labelId} className="pl-1 -mt-0.5">
            <IconInfoLight className="text-gray-dark "/>
          </Tooltip>
        </>
        }
      </label>
      <div className="col-span-5 flex ">
        {props.children}
      </div>
    </div>
  );
}
